import { AxiosRequestConfig } from "axios";
import { Report } from "src/Interfaces/TableInterfaces";
import {
  IWorkerHostPermissionReport,
  IWorkerHostPermissionSearchParam,
} from "src/Interfaces/workerHostPermission";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { getTable } from "./requestTemplates";

export const getWorkerHostPermissionTable = (
  searchParam: IWorkerHostPermissionSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<IWorkerHostPermissionReport>> =>
  getTable<IWorkerHostPermissionSearchParam, IWorkerHostPermissionReport>(
    "/v1/WorkerHostPermission/table",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );
